export function calcDescontoBaratinhas(
  cotacaoCents: number,
  limiteResgate: number,
  qntdeBaratinhas: number,
): number {

  const CENTS = 100;
  const DEFAULT_VALUE = 0;

  if (qntdeBaratinhas >= limiteResgate) {
    return (limiteResgate * cotacaoCents) / CENTS;
  }
  return DEFAULT_VALUE;
}

export function parseValorResgate(valorResgate: string): number {
  const sanitized = valorResgate.replace(/[^\d,]/g, '').replace(',', '.');
  return Number(sanitized) || 0;
}
